<template>
  <div class="company">
    <div class="company-content">
      <div class="content-box">
        <div class="content-breadcrumb cp">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item><a href="/company">公司动态和市场活动</a></el-breadcrumb-item>
            <el-breadcrumb-item>{{breadcrumbTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content-center">
          <div class="content-title clearfix">
            <div class="title-content cp" v-for="item in titleCon" :key="item.id"
                 :class="{ IsClick : clickTitle === item.id}">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="content-details clearfix">
            <div class="details-dynamic clearfix">
              <div class="details-dynamic-left">
                <div style="width:700px">
                  <h1 class="details-content-title">{{detailsCon.title}}</h1>
                  <span class="details-content-time">发布时间:{{detailsCon.year}}</span>
                  <div class="details-content-content" v-html="detailContent"></div>
                </div>
              </div>
              <div class="details-dynamic-right">
                <h1 class="dynamic-right-title">动态推荐</h1>
                <div class="dynamic-right-box">
                  <a class="details-bottom-box cp db" :href="diyClick(item.id)"
                     target="_blank"
                     v-for="item in diyCon">
                    <div class="bottom-box-img">
                      <img v-lazy="$global.globalPath + item.img" alt="动态推荐"
                           style="width:300px;height:200px;border-radius:5px"/>
                    </div>
                    <h2 class="bottom-box-span">{{item.title}}</h2>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'company',
  //  metaInfo () {
  //    return {
  //      title: this.$seo.company.title, // set a title
  //      meta: [{ // set meta
  //        name: 'keywords',
  //        content: this.$seo.company.keywords
  //      },
  //      {
  //        name: 'description',
  //        content: this.$seo.company.description
  //      }]
  //    }
  //  },
  data () {
    return {
      breadcrumbTitle: '公司动态',
      titleCon: [], // 分类数据源
      detailsCon: this.$store.state.newsContent || {},
      clickTitle: this.$route.query.cat_id || '6',
      newsData: {},
      detailContent: this.$store.state.newsContent.content || '',
      diyCon: [],
      currentId: this.$route.query.id || 1
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.getTitleConDate()
    next()
  },
  methods: {
    checkDetails () {
      this.getDetailsDate(this.currentId)
      this.getDiyDate(this.clickTitle)
    },
    diyClick (id) {
      let routeUrl = this.$router.resolve({
        name: 'CompanyDetail',
        query: {
          id: id,
          cat_id: this.clickTitle
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    // 获取分类标题
    getTitleConDate () {
      this.$api.post('/news/news_types', '', (r) => {
        if (r.code === 0) {
          this.titleCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取详情页
    getDetailsDate (id) {
      let a = {
        new_id: id
      }
      this.$api.post('/news/new_details', a, (r) => {
        if (r.code === 0) {
          this.detailsCon = r.data
          this.detailContent = r.data.content
        } else {
          this.detailContent = ''
          this.$message.error(r.message)
          this.$router.push({
            path: '/404'
          })
        }
      })
    },
    getDiyDate (id) {
      let a = {
        cat_id: id
      }
      this.$api.post('/news/news_diy', a, (r) => {
        if (r.code === 0) {
          this.diyCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    }
  },
  mounted () {
    this.getTitleConDate()
    this.checkDetails()
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/company.scss";
</style>



// WEBPACK FOOTER //
// companyDetail.vue?30307634